<template>
  <section class="py-5 px-3" style="background-color: #eef9f3;"> <!-- Light grey bg -->
    <div class="container">
      <div class="mx-auto p-4 bg-white shadow rounded" style="max-width: 720px;">
        <h1 class="display-6 text-center text-success mb-4" style="font-size: 2rem;">About Us</h1>

        <p class="mb-3" style="font-size: 1.05rem;">
          <strong>StepEdge Academy</strong> is an independent Computer Science school based in the UK, offering high-quality and forward-thinking education in 
          different domians of Computer Science for secondary school students at the GCSE and A-Level stages.
        </p>

        <p class="mb-3" style="font-size: 1.05rem;">
          Our mission is to empower the next generation of learners with practical skills and problem-solving strategies aligned with the modern digital world. We specialize in structured, exam-board-aligned courses that cover:
        Computer Science Theory, Imperative Programming, Networks & the Internet, Cyber Security and Artificial Intelligence (AI). 
        </p>

        <p class="mt-3" style="font-size: 1.05rem;">
          We deliver learning in each domain through 1-to-1 tuition, small-group classes, 
          intensive bootcamps, themed workshops, and project-based activities. This blended 
          approach introduces concepts, builds proficiency, and then deepens students’ 
          understanding through practical application.  </p>
           <p class="mt-3" style="font-size: 1.05rem;">
          The result is that students not only master their exam specifications but also gain the 
          confidence and portfolio evidence to pursue further study, apprenticeships, or early 
          work experience in the tech sector. </p>
           <p class="mt-3" style="font-size: 1.05rem;">
          Our programs are tailored for students aged 14–18, including international learners who follow British curricula such as 
          GCSE, A-Level, and the IBDP. We also support schools and parents by offering supplemental education that reinforces classroom learning while building deeper confidence in Computer Science.
          </p>

        <p style="font-size: 1.05rem;">
          Whether a student is preparing for exams or embarking on an ambitious practical project, StepEdge Academy provides the foundational knowledge and advanced tools to help them succeed in a tech-driven world.
        </p>

        <div class="text-end mt-5">
          <p class="mb-1 fw-bold">S KHAN</p>
          <p class="mb-1 fw-bold">Director</p>
          <p class="text-success fw-semibold">StepEdge Academy</p>
        </div>
      </div>
    </div>
  </section>
</template>

